import React from 'react';
import AtlasV2ConversionProductGrid from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionProductGrid';
import AtlasV2ConversionSplineChart from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionSplineChart';
import AtlasV2ConversionSplineV2Chart from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionSplineV2Chart';
import AtlasV2ConversionTopEntityChart from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionTopEntityChart';
import AtlasV2ConversionTopEntityV2Chart from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionTopEntityV2Chart';
import AtlasV2ConversionV2ProductGrid from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionV2ProductGrid';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { getTrafficV2Treatment } from 'src/utils/app';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

/**
 * Conversion Page in traffic tab = traffic, subtab = conversion
 *
 */
export const AtlasV2ConversionPageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <>
      {/* // this will use a combination of elastic search of unitsSold and doris traffic */}
      {getTrafficV2Treatment() !== 'off' && (
        <BasePageContainer>
          <AtlasV2ConversionSplineV2Chart />
          {!isProductEntity && <AtlasV2ConversionTopEntityV2Chart />}
          <AtlasV2ConversionV2ProductGrid />
        </BasePageContainer>
      )}
      {getTrafficV2Treatment() !== 'on' && (
        <BasePageContainer>
          <AtlasV2ConversionSplineChart />
          {!isProductEntity && <AtlasV2ConversionTopEntityChart />}
          <AtlasV2ConversionProductGrid />
        </BasePageContainer>
      )}
    </>
  );
};
